import { render, staticRenderFns } from "./editPropertyRightRegistration.vue?vue&type=template&id=1ccacec9&scoped=true"
import script from "./editPropertyRightRegistration.vue?vue&type=script&lang=js"
export * from "./editPropertyRightRegistration.vue?vue&type=script&lang=js"
import style0 from "./editPropertyRightRegistration.vue?vue&type=style&index=0&id=1ccacec9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccacec9",
  null
  
)

export default component.exports